import {
  Injectable,
  Input,
  ComponentFactoryResolver,
  Injector,
  ViewContainerRef,
  Type
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppSwitcherComponent } from '../components/app-switcher/app-switcher.component';

@Injectable()
export class CustomOverlayService {
  rootViewContainer: ViewContainerRef;
  @Input() cartComponentName: Type<any>; // Component to load dynamically
  @Input() modulePath: string; // Path to module file (for dynamic import)
  public menu;
  private menuOptions = new BehaviorSubject<Object[]>([]);
  currentMenuOptions = this.menuOptions.asObservable();

  constructor(
    private injector: Injector,
    private factoryResolver: ComponentFactoryResolver
  ) {
    this.menuOptions.subscribe(a => this.menu = a);
  }

  changeMenuItems(menuItems: any) {
    this.menu = menuItems;
    this.menuOptions.next(menuItems);
  }

  setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  async addDynamicComponent(containerId: string) {
    if (!this.rootViewContainer) {
      console.error('Root view container not set. Call setRootViewContainerRef first.');
      return;
    }

    if (!this.rootViewContainer.injector) {
      console.error('Injector is not available in the root view container.');
      return;
    }

    try {
      if (containerId === 'appSwitcherIcon') {
        const factory = this.factoryResolver.resolveComponentFactory(AppSwitcherComponent);
        const component = factory.create(this.rootViewContainer.injector);
        this.rootViewContainer.insert(component.hostView);
      } else if (this.modulePath) {
        try {
          const module = await import(this.modulePath);
          const moduleClass = module[this.modulePath.split('/').pop()]; // assumes named export matches file name
          if (!moduleClass) {
            console.error('Module class not found in:', this.modulePath);
            return;
          }

          if (!this.cartComponentName) {
            console.error('Cart component name not set for dynamic loading.');
            return;
          }

          const factory = this.factoryResolver.resolveComponentFactory(this.cartComponentName);
          const component = factory.create(this.rootViewContainer.injector);
          this.rootViewContainer.insert(component.hostView);
        } catch (error) {
          console.error('Failed to load module:', error);
        }
      } else {
        if (!this.cartComponentName) {
          console.error('Cart component name not set for dynamic loading.');
          return;
        }

        const factory = this.factoryResolver.resolveComponentFactory(this.cartComponentName);
        const component = factory.create(this.rootViewContainer.injector);
        this.rootViewContainer.insert(component.hostView);
      }
    } catch (error) {
      console.error('Error creating dynamic component:', error);
    }
  }
}

